import { render, staticRenderFns } from "./VariantSifterTableSettings.vue?vue&type=template&id=c3697aae&scoped=true&"
import script from "./VariantSifterTableSettings.vue?vue&type=script&lang=js&"
export * from "./VariantSifterTableSettings.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterTableSettings.vue?vue&type=style&index=0&id=c3697aae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3697aae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3697aae')) {
      api.createRecord('c3697aae', component.options)
    } else {
      api.reload('c3697aae', component.options)
    }
    module.hot.accept("./VariantSifterTableSettings.vue?vue&type=template&id=c3697aae&scoped=true&", function () {
      api.rerender('c3697aae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterTableSettings.vue"
export default component.exports